<template>
    <div class="live-host-replay info-box">
        <h3>直播回放</h3>

        <div class="replay-wrap sc-table">
            <el-table
                class="replay-table"
                :data="replayList"
                :border="false"
                :stripe="false"
            >
                <!-- column title -->
                <el-table-column prop="name" align="center" width="220px">
                    <template #default="{row}">
                        <div class="replay-banner" @click="viewReplay(row)" v-if="liveData.id">
                            <img class="live-thumb" :src="liveData.thumb" alt="封面">
                            <a class="icon-play"><i class="nucfont inuc-continue"></i></a>
                            <span v-if="row.is_default" class="default-tag">默认回放</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="subject" label="回放内容" align="left">
                    <template #default="{row}">
                        <div class="replay-title">
                            <h4>{{row.subject}}</h4>
                            <p>{{row.create_time}}</p>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="duration_format" label="时长" align="center" width="100px"></el-table-column>
                <el-table-column prop="status" label="状态" align="center" width="120px">
                    <template #default="{row}">
                        <span class="build-status doing" v-if="row.status===0">生成中..</span>
                        <span class="build-status success" v-else-if="row.status===1">正常</span>
                        <span class="build-status fail" v-else-if="row.status===2">生成失败</span>
                    </template>
                </el-table-column>
                <el-table-column prop="create_time" label="操作" align="center" width="150px">
                    <template #default="{row}">
                        <el-tag v-if="row.is_default" effect="dark" size="small">
                            <i class="el-icon-circle-check"></i> 默认回放</el-tag>
                        <el-button v-else @click="setDefaultReplay(row.id)" size="mini">设为默认回放</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <el-dialog :title="'内容预览 '+currentTitle"
                   :visible.sync="previewDialog"
                   :modal-append-to-body="false"
                   width="960px"
                   class="preview-dialog"
        >
            <iframe :src="previewUrl" class="preview-frame" frameborder="0" allowfullscreen='true'></iframe>
        </el-dialog>

    </div>
</template>

<script>
import dayjs from 'dayjs'
let duration = require('dayjs/plugin/duration')
dayjs.extend(duration)

export default {
    props: ['id', 'liveData'],

    components: {},

    data() {
        return {
            replayList: [],
            previewDialog: false,
            previewUrl: '',
            currentTitle: ''
        }
    },

    computed: {},

    mounted() {
        this.getReplayList()
    },

    methods: {
        async getReplayList() {
            let res = await this.$api.getLiveRoomReplay(this.id)
            this.replayList = res.package?.lists || []

            this.replayList.forEach(item => {
                item.duration_format = this.formatDuration(item.duration)
            })
        },

        async setDefaultReplay(recordId) {
            await this.$confirm('确定将该视频设置为默认回放吗？', this.$t('m.tip'), {type: 'warning'})

            await this.$api.setLiveRoomReplay(this.id, {recordId })

            this.$message.success('设置成功！')
            return this.getReplayList()
        },

        async viewReplay(row) {
            let res =  await this.$api.getLiveRoomReplayUrl(this.id, {rid: row.id})
            this.previewUrl = res.package
            this.previewDialog = true
            this.currentTitle = row.subject
        },

        formatDuration(duration) {
            let d = dayjs.duration(duration, 'seconds')
            let hours = (d.hours()+'').padStart(2, '0')
            let minutes = (d.minutes()+'').padStart(2, '0')
            let seconds = (d.seconds()+'').padStart(2, '0')

            return `${hours}:${minutes}:${seconds}`
        }
    },
}
</script>

<style lang="scss">
.live-host-replay {

    .replay-wrap {
        padding-left: 20px;
        width: 1000px;
    }

    .replay-banner {
        position: relative;
        cursor: pointer;
        &:hover {
            opacity: .8;
            .icon-play {
                background-color: rgba(0,0,0,.6);
                transform: scale(1.08);
            }
        }

        .live-thumb {
            max-width: 200px;
            max-height: 360px;
        }

        .icon-play {
            position: absolute;
            top: 50%;
            left: 50%;
            width: 42px;
            height: 42px;
            margin-top: -20px;
            margin-left: -20px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 50%;
            background-color: rgba(0,0,0,.4);
            transition: all .3s;

            .nucfont {
                font-size: 20px;
                color: #fff;
            }
        }

        .default-tag {
            position: absolute;
            right: 10px;
            bottom: 5px;
            padding: 0 6px;
            display: inline-block;
            line-height: 22px;
            background-color: rgba(0,0,0,0.6);
            color: #fff;
            border-radius: 4px;
            font-size: 12px;
        }
    }

    .replay-title {
        padding-left: 20px;
        > h4 {
            color: #333;
            font-weight: 600;
        }
        > p {
            margin-top: 20px;
            color: #777;
            font-size: 13px;
        }
    }

    .build-status {
        &.success {
            //color: $green;
        }
        &.fail {
            color: $red;
        }
        &.doing {
            color: $blue;
        }
    }

    .preview-dialog {
        .el-dialog__header {
            padding: 10px 20px;
            background-color: #ddd;
            button {
                top: 2px;
            }
        }

        .el-dialog__body {
            height: 540px;
            padding: 0;
            background-color: #2D2D2D;
        }

        .preview-frame {
            width: 100%;
            height: 100%;
        }
    }
}
</style>
